<---注册安全工程师 教辅-->
<template>
  <div class="container">
    <img :src="currentCourse.imgBgUrl" alt="" class="img" />
    <div class="input-container">
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_submit_btn.jpg" class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '《通关5+3》法律法规',
          id: 'BK202407040002',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_53_falvfagui_bg.jpg',
          promotedAccount: '注安教辅-5+3',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '法律法规',
              worthid: '628040151d2042b7b70aba78b7de3ed3',
              subjectid: 'b9ce86cfc4924e159fbe4ab05c1d6720'
            }
          ]
        },
        {
          name: '《通关5+3》生产管理',
          id: 'BK202407040003',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_53_shengchanguanli_bg.jpg',
          promotedAccount: '注安教辅-5+3',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '生产管理',
              worthid: '700898b3c2b8494fa004d72a307d7c37',
              subjectid: '2f99e2b3e5d047b98593ee9e1107268d'
            }
          ]
        },
        {
          name: '《通关5+3》技术基础',
          id: 'BK202407040004',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_53_jishujichu_bg.jpg',
          promotedAccount: '注安教辅-5+3',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '技术基础',
              worthid: 'a94407c722504e7bb8efbde40a25ceb4',
              subjectid: '426e5234964946fea16d03ee3fdc2096'
            }
          ]
        },
        {
          name: '《通关5+3》建筑施工安全',
          id: 'BK202407040005',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_53_jianzhushigong_bg.jpg',
          promotedAccount: '注安教辅-5+3',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全',
              worthid: '4f6a8b75c8624e569b65ad2b17130607',
              subjectid: 'ca45bfc15b9244cf920af56ec0e392c3'
            }
          ]
        },
        {
          name: '《通关5+3》化工安全',
          id: 'BK202407040006',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_53_huagonganquan_bg.jpg',
          promotedAccount: '注安教辅-5+3',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全',
              worthid: '48fae07778484a0680f536add888bcb4',
              subjectid: '39b46f0a68c04450887521a7c6106bf5'
            }
          ]
        },
        {
          name: '《通关5+3》其他安全',
          id: 'BK202407040007',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_53_qitaanquan_bg.jpg',
          promotedAccount: '注安教辅-5+3',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全',
              worthid: '5692b602763b4576b6c4f15a0dd2e8e6',
              subjectid: '766e2a61b4f84dc2a7eadd2a997208e4'
            }
          ]
        },
        {
          name: '注安《一点通》法律法规',
          id: 'BK202407040008',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgst_falvfagui_bg.jpg',
          promotedAccount: '注安教辅-一点通内',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '法律法规',
              worthid: '41fb899f7071400f9e92210589527979',
              subjectid: 'b9ce86cfc4924e159fbe4ab05c1d6720'
            }
          ]
        },
        {
          name: '注安《一点通》生产管理',
          id: 'BK202407040009',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgst_shengchanguanli_bg.jpg',
          promotedAccount: '注安教辅-一点通内',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '生产管理',
              worthid: 'f78d5d3c991049a7a00922949cf5b5bf',
              subjectid: '2f99e2b3e5d047b98593ee9e1107268d'
            }
          ]
        },
        {
          name: '注安《一点通》技术基础',
          id: 'BK202407040010',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgst_jishujichu_bg.jpg',
          promotedAccount: '注安教辅-一点通内',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '技术基础',
              worthid: 'f5ef0e83e73e484e8678ae925c16abb4',
              subjectid: '426e5234964946fea16d03ee3fdc2096'
            }
          ]
        },
        {
          name: '注安《一点通》建筑施工安全',
          id: 'BK202407040011',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgst_jianzhushigong_bg.jpg',
          promotedAccount: '注安教辅-一点通内',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全',
              worthid: '0b5d784b6da245319bb7a50532a32f0e',
              subjectid: 'ca45bfc15b9244cf920af56ec0e392c3'
            }
          ]
        },
        {
          name: '注安《一点通》化工安全',
          id: 'BK202407040012',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgst_huagonganquan_bg.jpg',
          promotedAccount: '注安教辅-一点通内',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全',
              worthid: '5bd60b2f347f404493ee3b7225369db7',
              subjectid: '39b46f0a68c04450887521a7c6106bf5'
            }
          ]
        },
        {
          name: '注安《一点通》其他安全',
          id: 'BK202407040013',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgst_qitaanquan_bg.jpg',
          promotedAccount: '注安教辅-一点通内',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全',
              worthid: 'd00af92d4c4d4091b1094c1f8d3072e9',
              subjectid: '766e2a61b4f84dc2a7eadd2a997208e4'
            }
          ]
        },
        {
          name: '注安《精讲一点通》法律法规',
          id: 'BK202407040014',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_yhjj_falvfagui_bg.jpg',
          promotedAccount: '注安教辅-一点通-外',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '法律法规',
              worthid: '701bf5ff97f745c1a5f8d66f3c7a49d8',
              subjectid: 'b9ce86cfc4924e159fbe4ab05c1d6720'
            }
          ]
        },
        {
          name: '注安《精讲一点通》生产管理',
          id: 'BK202407040015',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_yhjj_shengchanguanli_bg.jpg',
          promotedAccount: '注安教辅-一点通-外',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '生产管理',
              worthid: '66a38cb488294ec0b51e13809f0956ba',
              subjectid: '2f99e2b3e5d047b98593ee9e1107268d'
            }
          ]
        },
        {
          name: '注安《精讲一点通》技术基础',
          id: 'BK202407040016',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_yhjj_jishujichu_bg.jpg',
          promotedAccount: '注安教辅-一点通-外',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '技术基础',
              worthid: 'd41520e226ec405d9f3c889ef2e3c7e7',
              subjectid: '426e5234964946fea16d03ee3fdc2096'
            }
          ]
        },
        {
          name: '注安《精讲一点通》建筑施工安全',
          id: 'BK202407040017',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_yhjj_jianzhushigong_bg.jpg',
          promotedAccount: '注安教辅-一点通-外',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全',
              worthid: 'a752f2015ddb40fbac6428db971fb8bf',
              subjectid: 'ca45bfc15b9244cf920af56ec0e392c3'
            }
          ]
        },
        {
          name: '注安《精讲一点通》化工安全',
          id: 'BK202407040018',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_yhjj_huagonganquan_bg.jpg',
          promotedAccount: '注安教辅-一点通-外',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全',
              worthid: 'bd2051665bdf45478c6a45bb1e1c11bf',
              subjectid: '39b46f0a68c04450887521a7c6106bf5'
            }
          ]
        },
        {
          name: '注安《精讲一点通》其他安全',
          id: 'BK202407040019',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_yhjj_qitaanquan_bg.jpg',
          promotedAccount: '注安教辅-一点通-外',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全',
              worthid: '816a7cc9632b4696a18666784b542b03',
              subjectid: '766e2a61b4f84dc2a7eadd2a997208e4'
            }
          ]
        },
        {
          name: '注安-通关章节题 法律法规',
          id: 'BK202407040020',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgkd_falvfagui_bg.jpg',
          promotedAccount: '注安教辅-章节题',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '法律法规',
              worthid: '6ce45baece1045b3ab6faddb163175dc',
              subjectid: 'b9ce86cfc4924e159fbe4ab05c1d6720'
            }
          ]
        },
        {
          name: '注安-通关章节题 生产管理',
          id: 'BK202407040021',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgkd_shengchanguanli_bg.jpg',
          promotedAccount: '注安教辅-章节题',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '生产管理',
              worthid: 'fc0da8b0e85f418fb21d32042a26faad',
              subjectid: '2f99e2b3e5d047b98593ee9e1107268d'
            }
          ]
        },
        {
          name: '注安-通关章节题 技术基础',
          id: 'BK202407040022',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgkd_jishujichu_bg.jpg',
          promotedAccount: '注安教辅-章节题',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '技术基础',
              worthid: '01f2410f45bb47f2a9047847f6bf2c60',
              subjectid: '426e5234964946fea16d03ee3fdc2096'
            }
          ]
        },
        {
          name: '注安-通关章节题 建筑施工安全',
          id: 'BK202407040023',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgkd_jianzhushigong_bg.jpg',
          promotedAccount: '注安教辅-章节题',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全',
              worthid: '01c08f495dc14caf949a1415f1689be1',
              subjectid: 'ca45bfc15b9244cf920af56ec0e392c3'
            }
          ]
        },
        {
          name: '注安-通关章节题 化工安全',
          id: 'BK202407040024',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgkd_huagonganquan_bg.jpg',
          promotedAccount: '注安教辅-章节题',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全',
              worthid: '29803297ffdf464d9cf8a2a22d5e6c43',
              subjectid: '39b46f0a68c04450887521a7c6106bf5'
            }
          ]
        },
        {
          name: '注安-通关章节题 其他安全',
          id: 'BK202407040025',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/aqsjf/aqsjf_tgkd_qitaanquan_bg.jpg',
          promotedAccount: '注安教辅-章节题',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全',
              worthid: '930e87470f33427db8b3e47844960bcc',
              subjectid: '766e2a61b4f84dc2a7eadd2a997208e4'
            }
          ]
        }
      ],
      id: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true
    }
  },
  methods: {
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: this.currentCourse.collegeName,
        orign: '自主注册',
        promotedAccount: this.currentCourse.promotedAccount
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
        setTimeout(() => {
          window.location.href = 'https://www.zhongke3.com/zj-app-h5/zj_detail'
        }, 2000)
      })
    }
  },
  created() {
    this.id = this.$route.params.id
    this.currentCourse = this.list.find(item => item.id == this.id)
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 53vw;
    width: 100%;
    padding: 135vw 9.5vw 0;
    z-index: 1;

    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 4vw;
      input {
        flex: 1;
        border: none;
        outline: none;
        padding-left: 10px;
        border: 1px solid #f1f8ff;
        border-radius: 4px;
        font-size: 12px;
        height: 11vw;
        box-shadow: none;
        background: rgb(243, 244, 246);
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        color: rgb(252, 92, 14);
        border: 1px solid rgb(252, 92, 14);
        font-size: 12px;
        width: 99px;
        height: 45px;
        border-radius: 5px;
        background: #ffffff;
      }
    }

    .submit {
      margin: 6px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
      height: 13vw;
      width: 82%;
      background: none;
    }
  }
}
</style>
